import { useState } from "react";
import { Blog } from "../../models/blog";
import NewsModal from "./NewsModal";

export default function NewsEntry({
  news,
  index,
}: {
  news: Blog;
  index: number;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        className={"group flex flex-col lg:flex-row cursor-pointer gap-4"}
        onClick={() => setIsModalOpen(true)}
      >
        <div className="h-48 w-full lg:w-80 flex-shrink-0">
          <img
            className={`w-full h-full object-cover cursor-pointer rounded-2xl`}
            src={news.image}
            alt={news.title}
            onClick={() => setIsModalOpen(true)}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div
            className={
              "mt-3 text-md md:text-xl lg:text-xl 2xl:text-2xl font-bold break-words"
            }
          >
            {news.title}
          </div>
          <div className="text-sm md:text-base lg:text-sm flex flex-row gap-2">
            {news.date && <strong>Wann?</strong>}
            {news.date}
          </div>
          <div className="text-sm md:text-base lg:text-sm">
            <div className="relative">
              <p className="line-clamp-3 2xl:line-clamp-5 pr-2">
                {news.excerpt}
              </p>
              <div className="pointer-events-none absolute inset-x-0 bottom-0 h-6 bg-gradient-to-t from-white to-transparent" />
            </div>
            <div className="mt-3 inline-flex w-fit items-center gap-2 rounded-full border border-red-700 px-4 py-1.5 text-xs md:text-sm font-bold text-red-700 transition-colors group-hover:bg-red-700 group-hover:text-white">
              Mehr erfahren
              <span aria-hidden="true" className="text-base leading-none">
                ›
              </span>
            </div>
          </div>
        </div>
      </div>

      <NewsModal
        news={news}
        isOpen={isModalOpen}
        close={() => setIsModalOpen(false)}
      />
    </>
  );
}
